import React, { FC, useCallback } from 'react';
import { FieldValues, FormProvider, useForm, UseFormReturn } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import Modal from '../../../components/Modal/NewModal';
import { TextField } from '../../../components/ReactHookForm';
import { newGroupValidation } from '../../../utils/groups/validationSchema';

interface NewGroupModalProps {
  onSubmit: (data: { name: string; planNumber: string }) => void;
  onCancel: () => void;
}

export const NewGroupModal: FC<NewGroupModalProps> = ({ onSubmit, onCancel }) => {
  const methods: UseFormReturn<FieldValues> = useForm({
    mode: 'onChange',
    reValidateMode: 'onSubmit',
    resolver: joiResolver(newGroupValidation)
  });

  const { getValues, trigger } = methods;

  const handleSubmit = useCallback(async () => {
    (await trigger()) && onSubmit(getValues() as { name: string; planNumber: string });
  }, [getValues, trigger, onSubmit]);

  return (
    <Modal
      isOpen
      onClose={onCancel}
      contentLabel="New Employer Group Modal"
      title="New Employer Group Modal"
      header="New Employer Group"
      size="default"
      actions={[
        { title: 'Cancel', kind: 'secondary' },
        {
          title: 'Continue',
          kind: 'primary',
          autoClose: false,
          onClick: handleSubmit
        }
      ]}
    >
      <FormProvider {...methods}>
        <form className="w-full p-8">
          <TextField name="name" label="Group Name" required />
          <TextField name="planNumber" label="Group Number" required />
        </form>
      </FormProvider>
    </Modal>
  );
};
